import AppContext from 'App/AppContext';
import { IPFontIcon, IPLink } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { ApprovalButtonApprove, ApprovalButtonReject } from 'components/Buttons/ApprovalButton';
import { globalStackTokensGapExtraSmall, globalStackTokensGapMedium, globalStackTokensGapSmall } from 'globalStyles';
import { ApprovalState } from 'models/approval';
import Task from 'models/tasks/task';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

interface IProcessingActivityApprovalTaskDetailItems {
  task: Task;
  compact?: boolean;
  navigateExternal?: boolean;
  onUpdate: (newTask: Task) => void;
}

export const ProcessingActivityApprovalTaskDetailItems = (props: IProcessingActivityApprovalTaskDetailItems) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation(['library', 'translation']);
  const iconFontSize = { fontSize: '20px', marginTop: '5px' };

  const isApprovedOrRejected = (): boolean => {
    return props.task.approved !== ApprovalState.Pending;
  };

  //
  // Main render
  //
  return (
    <IPStack tokens={globalStackTokensGapSmall}>
      <IPStack.Item>
        <IPStack
          horizontal
          tokens={appContext.isMobileView ? globalStackTokensGapExtraSmall : globalStackTokensGapMedium}
          verticalAlign="start"
          styles={{ root: { paddingTop: 10 } }}
        >
          <IPStack.Item>
            {!appContext.isMobileView && <IPFontIcon iconName="FavoriteStarFill" style={iconFontSize} />}
          </IPStack.Item>
          <IPStack.Item grow>
            <IPStack
              horizontal
              wrap
              tokens={globalStackTokensGapSmall}
              verticalAlign="center"
              styles={{ root: { paddingRight: 5 } }}
            >
              <IPStack.Item>
                <ApprovalButtonApprove
                  compact={props.compact}
                  selected={props.task.approved === ApprovalState.Approved}
                  disabled={appContext.user.id !== props.task.userId}
                  onClick={() => {
                    const copyTask = props.task.clone();
                    copyTask.approved = ApprovalState.Approved;
                    props.onUpdate(copyTask);
                  }}
                />
              </IPStack.Item>
              <IPStack.Item>
                <ApprovalButtonReject
                  compact={props.compact}
                  selected={props.task.approved === ApprovalState.Rejected}
                  disabled={appContext.user.id !== props.task.userId}
                  onClick={() => {
                    const copyTask = props.task.clone();
                    copyTask.approved = ApprovalState.Rejected;
                    props.onUpdate(copyTask);
                  }}
                />
              </IPStack.Item>
              <IPStack.Item>
                <IPLink
                  disabled={appContext.user.id !== props.task.userId || !isApprovedOrRejected()}
                  onClick={() => {
                    const copyTask = props.task.clone();
                    copyTask.approved = ApprovalState.Pending;
                    copyTask.taskStateId = copyTask.getFirstState();
                    props.onUpdate(copyTask);
                  }}
                >
                  {t('library:ApprovalTasks.ApprovalTaskDetail.ResetAnswer')}
                </IPLink>
              </IPStack.Item>
            </IPStack>
          </IPStack.Item>
        </IPStack>
      </IPStack.Item>
    </IPStack>
  );
};
